import moment from 'moment';
import 'moment/locale/et';

import React, { useState } from 'react';
import {BrowserRouter, Redirect, Route, RouteComponentProps, Switch} from 'react-router-dom';

import {Header} from 'components/Header/Header';
import {Footer} from 'components/Footer/Footer';

import 'App.scss';
import 'react-dates/initialize';

import {CustomerRole, IActivePage, Pages} from 'pages/pages';
import AuthContext from "./services/context/authentication.context";

import { CookieAgreement } from 'components/CookieAgreement/CookieAgreement';
import { ToastContainer } from 'react-toastify';
import { axiosInterceptor } from 'helpers/axiosInterceptor';

moment.locale('et');

declare global {
    interface Window {
        opera: any,
        ReactNativeWebView: any,
        dataLayer: any[]
    }
}

window.dataLayer = window.dataLayer || [];
window.opera = window.opera || undefined;
window.ReactNativeWebView = window.ReactNativeWebView || undefined;

export const AS_CUSTOMER_PATH = "/as-customer";

export default function App() {
    axiosInterceptor();

    const [isUtilityPage, setUtilityPage] = useState(true);
    const [currentPage, setCurrentPage]: [IActivePage, any] = useState({
        path: '/login', 
        isPublic: true, 
        requiredRoles: null, 
        onlyShowForPersons: false,
        onlyShowForCompany: false,
        mustHaveGroupId: null,
        footerHidden: false,
        headerHidden: true
    });

    const populateMain = Pages.map((page) =>
        <Route
            exact
            key={page.title}
            path={'/' + page.title}
            render={
                (props: RouteComponentProps) =>
                    (<page.component
                        {...props} onLoadValidatePage={() => onLoadValidatePage(setUtilityPage, setCurrentPage,
                        page.isUtility, page.isPublic, props.match.path, page.requiredRoles,
                        page.onlyShowForPersons, page.onlyShowForCompany || false, page.mustHaveGroupId, page.footerHidden, page.headerHidden)}/>)
            }
        />);


    return (
        <BrowserRouter basename=''>
            <Switch>
                <Route exact path='/avaleht'>
                    <Redirect to='/esileht'/>
                </Route>
                <Route exact path='/'>
                    <Redirect to='/esileht'/>
                </Route>
            </Switch>
            <AuthContext currentPage={currentPage}>
                {
                    !currentPage.headerHidden ? (
                        <Header utilityPageState={isUtilityPage}/>
                    ) : <header />
                }
                <main className={(isUtilityPage ? 'utilityPage' : '') + (currentPage.footerHidden ? ' no-footer' : '')}>
                    <Switch>
                        {
                            populateMain
                        }
                    </Switch>
                </main>
                <Footer utilityPageState={isUtilityPage} footerHidden={currentPage.footerHidden}/>
                <CookieAgreement />
                <ToastContainer />
            </AuthContext>
        </BrowserRouter>
    );
}

function onLoadValidatePage(
    setUtilityPage: React.Dispatch<React.SetStateAction<boolean>>,
    setCurrentPage: React.Dispatch<React.SetStateAction<IActivePage>>,
    isUtility: boolean, isPublic: boolean, currentLocation: string, 
    requiredRoles: Array<CustomerRole> | null, onlyShowForPersons: boolean, 
    onlyShowForCompany: boolean,
    mustHaveGroupId: Array<String> | null, 
    footerHidden?: boolean,
    headerHidden?: boolean
) {
    setUtilityPage(isUtility);
    setCurrentPage({
        path: currentLocation, 
        isPublic: isPublic, 
        requiredRoles: requiredRoles, 
        onlyShowForPersons: onlyShowForPersons,
        onlyShowForCompany: onlyShowForCompany,
        mustHaveGroupId: mustHaveGroupId,
        footerHidden: footerHidden,
        headerHidden: headerHidden
    });
}